module.exports = "pegasus_template/assets/lp/ebook/bg1.png";